const SELF_MANAGED = 1;
const INVOICED = 2;

export {
    SELF_MANAGED,
    INVOICED
}